import {useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';

import {sessionKeys} from './keys';

/**
 * Recharge le profil, les organisations et les notifications.
 *
 * Remplace les `dispatch(getMe())` disséminés après chaque action susceptible de
 * modifier le profil et qui n'est pas une mutation du domaine : retour d'une
 * connexion OAuth (Notion, Canva, Google, Microsoft), fin d'authentification,
 * retour de paiement Stripe. Les mutations, elles, invalident déjà seules.
 */
export function useRefreshMe() {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({queryKey: sessionKeys.me()});
  }, [queryClient]);
}
